import MoveUpAnimation from '../components/MoveUpAnimation'
import PageBase from '../components/PageBase'
import { useAppT } from '../localization/config'

export default function TherapyPage() {
  const t = useAppT()

  return (
    <PageBase title={t.therapy_title} subtitle={t.therapy_subtitle} scroolToTop>
      <MoveUpAnimation>
        <p>
          <strong>{t.therapy_format_label}</strong> {t.therapy_format_value}
        </p>
        <p>
          <strong>{t.therapy_duration_label}</strong> {t.therapy_duration_value}
        </p>
        <p>
          <strong>{t.therapy_price_label}</strong> {t.therapy_price_value}
        </p>

        <h3 className="mt-8">🔮 {t.therapy_about_title}</h3>
        <p>{t.therapy_about_text}</p>

        <h3 className="mt-8">📖 {t.therapy_process_title}</h3>
        <p className="mt-4 font-semibold">{t.therapy_process_1_title}</p>
        <ul className="list-[circle] mt-2">
          <li>{t.therapy_process_1_item_1}</li>
          <li>{t.therapy_process_1_item_2}</li>
          <li>{t.therapy_process_1_item_3}</li>
        </ul>

        <p className="mt-4 font-semibold">{t.therapy_process_2_title}</p>
        <p className="mt-1">{t.therapy_process_2_text}</p>

        <h3 className="mt-8">✨ {t.therapy_receive_title}</h3>
        <p>{t.therapy_receive_text}</p>
      </MoveUpAnimation>
    </PageBase>
  )
}
